import { REGISTER } from "reduxjs-toolkit-persist";

const constants = {
  // api methods
  POST_METHOD: "POST",
  GET_METHOD: "GET",
  PUT_METHOD: "PUT",
  DELETE_METHOD: "DELETE",

  //auth apis
  LOGIN: "auth/v1/login",
  FORGOT_PASSWORD: "auth/v1/forgot-password",
  OTP_VERIFY: "auth/v1/verify-otp",
  VERIFY_RESET_OTP: "auth/v1/verify-reset-otp",
  RESET_PASSWORD: "auth/v1/reset-password",
  RESEND_CODE: "auth/v1/send-otp",

  //patient
  GET_UHID: "patient/v1/uhid",
  REGISTER_PATIENT: "patient/v1",
  GET_PATIENTS: "patient/v1",
  GET_PATIENT: "patient/v1",
  GET_PATIENT_APPOINTMENT: "appointment/v1/user",

  //user
  UPLOAD_IMAGE: "user/v1/image",
  REGISTER_USER: "user/v1",
  GET_USERS: "user/v1",
  GET_USER: "user/v1",
  DELETE_USER: "user/v1",
  UPDATE_USER: "user/v1",

  //roles
  GET_ROLES: "role/v1",
  UPDATE_ROLE: "role/v1",

  //appointment
  REGISTER_APPOINTMENT: "appointmentNconsultation/v1/",
  GET_APPOINTMENTS: "appointmentNconsultation/v1/type/Appointment",
  GET_APPOINTMENT: "appointmentNconsultation/v1/",
  UPDATE_APPOINTMENT: "appointmentNconsultation/v1/",

  //consultation
  REGISTER_CONSULTATION: "appointmentNconsultation/v1/",
  GET_CONSULTATIONS: "appointmentNconsultation/v1/type/Consultation",
  GET_CONSULTATION: "appointmentNconsultation/v1/",
  UPDATE_CONSULTATION: "appointmentNconsultation/v1/",
  CHECK_FOLLOWUP_ELIGIBILITY: "consultation/v1/check-followup-eligibility",

  //master data
  ADD_MASTER_DATA: "master/v1",
  GET_MASTER_DATA: "master/v1",
  GET_OPD_CASE_PAPER: "master/v1/opd-case-paper",
  GET_IPD_CASE_PAPER: "master/v1/ipd-case-paper",
  GET_PATHOLOGY_PRINT: "pathology/v1/report",
  SPECIALIZATIONS: [
    "Cardiology",
    "Neurology",
    "Orthopedics",
    "Pediatrics",
    "Gynocology",
    "Dermatology",
    "Medicine",
    "Dental",
    "Other",
  ],
  DESIGNATIONS: ["Doctor", "Nurse", "Reception", "Pathology/Radiology"],
  DEPARTMENTS: [
    "Doctor",
    "Nurse",
    "Reception",
    "Pathology/Radiology",
    "Billing",
  ],
  PERMISSIONS: [
    // Module Access Permissions
    "Dashboard",
    "Consultation",
    "Patients",
    "Appointments",
    "Nursing",
    "Pharmacy",
    "Pathology",
    "Radiology",
    "Store",
    "Billing & Payments",
    "Reports",
    "User",
    "Settings",
    "Role",
    "Master",
    
    // Basic CRUD Operation Permissions
    "Patients.Create",
    "Patients.Read", 
    "Patients.Update",
    "Patients.Delete",
    
    "Users.Create",
    "Users.Read",
    "Users.Update", 
    "Users.Delete",
    
    "Appointments.Create",
    "Appointments.Read",
    "Appointments.Update",
    "Appointments.Delete",
    
    "Consultations.Create",
    "Consultations.Read",
    "Consultations.Update",
    "Consultations.Delete",
    
    "Pathology.Create",
    "Pathology.Read",
    "Pathology.Update",
    "Pathology.Delete",
    
    "Radiology.Create",
    "Radiology.Read",
    "Radiology.Update",
    "Radiology.Delete",
    
    "Suppliers.Create",
    "Suppliers.Read",
    "Suppliers.Update",
    "Suppliers.Delete",
    
    "Roles.Create",
    "Roles.Read",
    "Roles.Update",
    "Roles.Delete",
    
    // Medical Department Specific Permissions
    "Consultation.Create",
    "Consultation.Read",
    "Consultation.Update",
    
    "Nursing.Create",
    "Nursing.Read",
    "Nursing.Update",
    "Nursing.Delete",
    "Nursing.Records.Access",
    "Nursing.Care.Plans",
    "Nursing.Medications",
    
    "Pharmacy.Dispensing",
    "Pharmacy.Inventory",
    "Pharmacy.Prescriptions",
    
    "Radiology.Scans.Order",
    "Radiology.Images.View",
    "Radiology.Reports.Generate",
    
    "Pathology.Tests.Order",
    "Pathology.Results.View",
    "Pathology.Reports.Generate",
    
    "Store.Create",
    "Store.Read",
    "Store.Update",
    "Store.Delete",
    "Store.Inventory.View",
    "Store.Stock.Update",
    "Store.Requests.Create",
    
    "Reports.Patient.Access",
    
    // Advanced Administrative Permissions
    "System.Settings.Manage",
    "System.Backup.Create",
    "System.Logs.Access",
    "System.Audit.Access",
    "Users.Role.Manage",
    "Users.Permissions.Manage",
    
    // Super Admin Only Permissions
    "SuperAdmin.All.Access",
    "SuperAdmin.Users.Create",
    "SuperAdmin.Roles.Manage",
    "SuperAdmin.System.Configure",
    "SuperAdmin.Data.Export",
    "SuperAdmin.Data.Import",
    
    // Financial & Sensitive Operations
    "Billing.Refund.Process",
    "Billing.Payments.Void",
    "Reports.Financial.Access",
    "Reports.Audit.Access",
  ],
};

export default constants;
